<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <RequestorType :is_master="true" />
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    const RequestorType = () => import('./requester-type')
    export default {
        name: 'case-settings-requester-type-master',
        components: {
            RequestorType
        }
    }
</script>
